/**
 * The one way the shell opens a file in a window (cdb_webos#1619): the window
 * gets a `FileRef` in its params and loads the file itself, so a reload or a
 * deep link opens it again.
 *
 * Every file opens in the one preview window, `file-preview` (#1648); audio
 * and recordings play there too.
 */
import type { AppId } from '@/data/apps'
import type { WindowParams } from '@/types/window'
import { fileRefToParams, type FileRef } from './fileRef'

type OpenWindow = (appId: AppId, title?: string, subtitle?: string, params?: WindowParams) => unknown

export interface OpenFileOptions {
  title?: string
  subtitle?: string
  /** Extra window params, e.g. `page`, `t`, `fileSize`, `fileDuration`. */
  params?: WindowParams
}

export function openFile(ref: FileRef, openWindow: OpenWindow, options: OpenFileOptions = {}): void {
  openWindow('file-preview', options.title, options.subtitle, { ...options.params, ...fileRefToParams(ref) })
}
